module.exports = __webpack_public_path__ + "img/topTitle.6ec05e41.png";